// extracted by mini-css-extract-plugin
var _1 = "styles-module__changeImage___fOY8_";
var _2 = "styles-module__imageContainer___ywidH";
export { _1 as "changeImage", _2 as "imageContainer" }
